import { Helmet } from "react-helmet";
import invoices from "../../asset/images/InvoiceFactoring.svg";
import trade from "../../asset/images/workingCapital.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TabList from "component/pay/TabList";
import axios from "axios";
import FinanceRequestModalLoan from "../../component/TransactionDetail2";
import Notice from "../../component/notice";
import PageTitle from "component/layout/pay/PageTitle";
import { useSelector } from "react-redux";
import Navbar from "component/layout/navbar";
import Credits from "component/finance/Credits";
import History from "component/finance/History";
import { ENDPOINTS } from "constants/endpoints";
import NewDashboardLayout from "component/layout/NewDashboardLayout";
import { useQueryState } from "nuqs";

const Finance = () => {
    const navigate = useNavigate();
    const [selectedIndex, setselectedIndex] = useState(-1);
    const [mydate, setmydate] = useState(new Date());
    const [invoice, setinvoices] = useState([]);
    const selectorbusiness = useSelector((state) => state.business);

    const [inputSearch, setinputsearch] = useState("");
    const [loaderset, setloaderset] = useState(true);
    const [tab, settab] = useState("all");
    const [maintab, setmaintab] = useState("Instruments");
    const [searchbank, setsearchbank] = useState("");
    const [show, sethsow] = useState(false);
    const [transaction, settransaction] = useState([]);
    const [shownotice, setshownotice] = useState(false);
    const [summary, setSummary] = useState([]);

    const tabs = [
        { key: "Instruments", label: "Credits" },
        { key: "History", label: "History" },
    ];
    const [activeTab, setActiveTab] = useQueryState("tab", {
        defaultValue: 'Instruments',
    });

    const businessIdHeaderConfig = {
        headers: { "x-business-id": selectorbusiness?._id },
    };

    const getfinance = (index) => {
        setselectedIndex(index);
        if (index === 0) {
            navigate("/finance/invoice");
        } else if (index === 1) {
            navigate("/trade_of_credit/home");
        }
    };

    useEffect(() => {
        const fetchaccount = async () => {
            await axios
                .get(ENDPOINTS.financeAll, businessIdHeaderConfig)
                .then((res) => {
                    //console.log(res);
                    setinvoices(res.data.slice(0, 10));
                    setloaderset(false);
                })
                .catch((e) => {
                    console.log(e);
                    setloaderset(false);
                });
        };
        selectorbusiness?._d && fetchaccount();
    }, [selectorbusiness]);

    useEffect(() => {
        const fetchSummary = async () => {
            await axios
                .get(ENDPOINTS.financeSummary, businessIdHeaderConfig)
                .then((res) => {
                    setSummary(res.data);
                    //  console.log(res);
                })
                .catch((e) => {
                    setSummary([]);
                    console.log(e);
                });
        };
        selectorbusiness?._id && fetchSummary();
    }, [selectorbusiness]);
    //console.log(invoice);

    const filteredData = invoice.filter(
        (item) =>
            (item.requestedAmount && item.requestedAmount.toString().includes(inputSearch)) ||
            (item.currency && item.currency.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.tenure && item.tenure.toString().includes(inputSearch)) ||
            (item.user && item.user.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.invoiceType &&
                item.invoiceType.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.paymentStatus &&
                item.paymentStatus.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.requestTitle &&
                item.requestTitle.toLowerCase().includes(inputSearch.toLowerCase())) ||
            (item.annualRevenue && item.annualRevenue.toString().includes(inputSearch)) ||
            (item.annualTurnOver && item.annualTurnOver.toString().includes(inputSearch)) ||
            (item.businessName && item.businessName.toString().includes(inputSearch)) ||
            (item.financeType && item.financeType.toString().includes(inputSearch)) ||
            (item.loanAmount && item.loanAmount.toString().includes(inputSearch))
    );

    const filterInvoice = filteredData.filter((item) =>
        item.status?.toLowerCase()?.includes(searchbank?.toLowerCase())
    );

    invoice.sort((a, b) => a.createdAt.localeCompare(b.createdAt, "es", { sensitivity: "base" }));
    let datass = filterInvoice.reduce((r, e) => {
        let alphabet = new Date(e.createdAt).toDateString();
        if (!r[alphabet])
            r[alphabet] = {
                alphabet,
                record: [],
            };

        r[alphabet].record.push(e);
        return r;
    }, {});

    const finance = [
        {
            title: "Invoice Factoring",
            opt: "Sell your invoice for immediate cash",
            image: invoices,
        },

        {
            title: "Working Capital",
            opt: "Get a quick loan for your transaction",
            image: trade,
        },
    ];

    return (
        // <div className="h-100 w-100 ">
        <NewDashboardLayout>
            <div
                className=""
                style={{
                    maxWidth: "2000px",
                    margin: "0px auto",
                }}
            >
                <Helmet>
                    <title>Tradevu — finance</title>
                </Helmet>

                {/* <Navbar /> */}

                <FinanceRequestModalLoan
                    setshownotice={setshownotice}
                    show={show}
                    setshow={sethsow}
                    data={transaction}
                />
                <Notice show={shownotice} setshow={setshownotice} data={transaction} />
            </div>
            <div className="h-full max-w-[2000px] mx-auto w-full flex flex-col gap-12 mt-8">
                <PageTitle
                    title="Finance"
                    description="Access capital using the following options"
                />
            </div>

            <div className="mx-auto pb-2.5 w-full">
                <div className="flex flex-col w-full h-full mx-auto mt-10">
                    <TabList
                        tabs={tabs}
                        activeTab={activeTab}
                        onTabChange={(key) => setActiveTab(key)}
                    />

                    {activeTab === "Instruments" && <Credits />}

                    {activeTab === "History" && <History />}
                </div>
            </div>
        </NewDashboardLayout>
        // </div>
    );
};

export default Finance;
